/**
 * Which pd job holds the processing lock of a partner.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdProcessingKind} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdProcessingKindEnum {
    COLLECTION,
    EXPORT,
}
